import {cs}     from "@Common/react/chain-services";
import {Static} from "@Common/react/static";

import {DomSizeObserver} from "../../../../dom-size-observer";

import {calculateGrid} from "./calculate-grid";

export const ItemGrid = ({minWidth, maxWidth, minGap, maxGap, count, stretch, next}) => cs(
    ["domSizeObserver", (_, next) => DomSizeObserver({defaultValue:null, next})],
    ["width", ({domSizeObserver}, next) => AntiScrollbarWidth({value: domSizeObserver.value?.width, next})],
    ({domSizeObserver, width}) => next({
        containerRef: domSizeObserver.ref,
        ...count && cs(
            ["width", (_, next) => {
                if (!width) {
                    return null;
                }
                return next(width);
            }],
            ({width}) => calculateGrid({totalWidth: width, minWidth, maxWidth, minGap, maxGap, count, stretch}),
        ),
    }),
);

const AntiScrollbarWidth = ({value, next}) => cs(
    ["ref", (_, next) => Static({initValue: {},next})],
    ({ref}) => {
        if (value == null) {
            return next(value);
        }

        // console.log({value, "ref.last": ref.last})
        if (ref.last && ref.last < value && value - ref.last < 30 ) {
            return next(ref.last);
        } else {
            ref.last = value;
            return next(value);
        }
    },
);
